import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import Signet from '../../../assets/logo/neoskop-logo.svg'
import { PageContext } from '../../../context/PageContext'
import useScrollState from '../../hooks/useScrollState'
import './styles.scss'

const Logo = ({ invert }) => {
  const { showLogo, transformLogo } = useContext(PageContext)

  const [invertState, setInvertState] = useState(invert)

  const { aboveTheFold } = useScrollState()

  useEffect(() => {
    if (invert) {
      aboveTheFold ? setInvertState(true) : setInvertState(false)
    }
  }, [aboveTheFold, invert])

  return (
    <div
      className={cx({
        'animated-logo': true,
        'animated-logo--invert': invertState,
        'animated-logo--downsized': transformLogo,
        'is-visible': showLogo,
        'is-hidden': !showLogo
      })}
    >
      <Signet />
      <div
        className={cx({
          'animated-logo__rectangle': true,
          'animated-logo__rectangle--invert': invertState,
          'animated-logo__rectangle--downsized': transformLogo
        })}
      >
        <svg width="40" height="40">
          <rect />
        </svg>
      </div>
    </div>
  )
}

Logo.propTypes = {
  invert: PropTypes.bool
}

Logo.defaultProps = {
  invert: false
}

export default Logo
